import { Card, Skeleton } from 'antd';

/**
 * Shown while a lazy route's chunk is still downloading
 * (docs/07-implementation-roadmap.md F0.7).
 *
 * A skeleton rather than a spinner: it holds the space the screen is about to
 * occupy, so the page doesn't jump when the content lands.
 */
export function RouteFallback() {
  return (
    <Card>
      <Skeleton active paragraph={{ rows: 6 }} />
    </Card>
  );
}
